import React from 'react'
import Button from './Button'

export default function Hero() {
    return (
        <>
            <div className='w-full py-5 sm:py-14 bg-cover bg-center hero_bg flex flex-wrap flex-col-reverse md:flex-row items-center md:justify-center gap-8 lg:gap-[20%]'>
                <div className='text-center md:text-start max-w-[450px]'>
                    <p className='text-[16px] text-[#F64B4B] z-10 mb-1'>Let’s shift your business</p>
                    <h2 className='hidden sm:block text-[18px] sm:text-[28px] md:text-[39px] font-extrabold mb-2'>Shift your business <br />fast with simplify.</h2>
                    <h2 className='block sm:hidden text-[18px] sm:text-[28px] md:text-[39px] font-extrabold mb-2'>Shift your business  fast with simplify.</h2>
                    <p className='text-gray-400 font-semibold mb-3 text-[16px]'>Unlock the full potential of your business empowering you to establish a powerful online presence and drive unparalleled growth.</p>

                    <Button text="Get Started with project" />
                </div>
                <div className='relative '>
                    <img src={process.env.REACT_APP_PUBLIC_URL + '/images/laptop.png'} alt="laptop" />
                    <img className='animate-1' src={process.env.REACT_APP_PUBLIC_URL + '/images/green_circle.png'} alt="green circle" />
                    {/* <img className='absolute top-0 left-0 animate-2' src={process.env.REACT_APP_PUBLIC_URL + '/images/dots.png'} alt="dots" />
                    <img className='absolute top-0 left-0 animate-3' src={process.env.REACT_APP_PUBLIC_URL + '/images/lines.png'} alt="lines" /> */}

                </div>
            </div>

           

            

        </>
    )
}
